import { render, staticRenderFns } from "./ExportFiles.vue?vue&type=template&id=674d9bb0&"
import script from "./ExportFiles.vue?vue&type=script&lang=js&"
export * from "./ExportFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports